/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOwnProfileDto
 */
export interface UpdateOwnProfileDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOwnProfileDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOwnProfileDto
     */
    email?: string;
}

/**
 * Check if a given object implements the UpdateOwnProfileDto interface.
 */
export function instanceOfUpdateOwnProfileDto(value: object): value is UpdateOwnProfileDto {
    return true;
}

export function UpdateOwnProfileDtoFromJSON(json: any): UpdateOwnProfileDto {
    return UpdateOwnProfileDtoFromJSONTyped(json, false);
}

export function UpdateOwnProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOwnProfileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function UpdateOwnProfileDtoToJSON(json: any): UpdateOwnProfileDto {
    return UpdateOwnProfileDtoToJSONTyped(json, false);
}

export function UpdateOwnProfileDtoToJSONTyped(value?: UpdateOwnProfileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
    };
}

